import React from 'react';
import styled from 'styled-components';
import Layout from '../../components/Layout';
import { Link } from 'react-router-dom';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  text-align: center;
  padding: 2rem;
`;

const ErrorHeading = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.primary};
`;

const ErrorText = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: ${props => props.theme.colors.text};
`;

const HomeButton = styled(Link)`
  padding: 0.8rem 1.5rem;
  background-color: ${props => props.theme.colors.primary};
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 500;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${props => props.theme.colors.primaryDark};
  }
`;

const Error: React.FC = () => {
  return (
    <Layout>
      <ErrorContainer>
        <ErrorHeading>404</ErrorHeading>
        <ErrorText>Sorry, this page doesn't exist.</ErrorText>
        <HomeButton to="/">Return to Home</HomeButton>
      </ErrorContainer>
    </Layout>
  );
};

export default Error; 